export const ORGANIZATIONS_PAGINATION_LIMIT = 50;
export const ORGANIZATIONS_PAGINATION_BATCH_SIZE = ORGANIZATIONS_PAGINATION_LIMIT;
